import { PORTAL_HEADER } from './storage';

export function buildPortalAuthHeaders(portalId, extra = {}) {
  const headers = { ...extra };
  if (portalId) headers[PORTAL_HEADER] = portalId;
  // Auth via HttpOnly portal cookie (credentials: 'include'). Do not read JWT from storage.
  return headers;
}

/** Supports legacy (portalId, tokenStorageKey, extra) and cookie-only (portalId, extra). */
export function portalFetchInit(portalId, extraOrLegacyKey = {}, maybeExtra = {}) {
  const extra =
    typeof extraOrLegacyKey === 'string' || extraOrLegacyKey == null
      ? maybeExtra
      : extraOrLegacyKey;
  const { headers: extraHeaders, ...rest } = extra || {};
  return {
    credentials: 'include',
    ...rest,
    headers: buildPortalAuthHeaders(portalId, extraHeaders || {}),
  };
}
